import React, { useMemo } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { TrendingUp } from "lucide-react";

const weekStart = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  x.setDate(x.getDate() - ((x.getDay() + 6) % 7));
  return x;
};

export const LeadsChart = ({ leads }) => {
  const data = useMemo(() => {
    const weeks = [];
    const now = weekStart(new Date());
    for (let i = 7; i >= 0; i--) {
      const start = new Date(now);
      start.setDate(start.getDate() - i * 7);
      weeks.push({
        key: start.getTime(),
        label: start.toLocaleDateString("en-GB", { day: "numeric", month: "short" }),
        count: 0,
      });
    }
    (leads || []).forEach((l) => {
      const k = weekStart(new Date(l.created_at)).getTime();
      const w = weeks.find((x) => x.key === k);
      if (w) w.count += 1;
    });
    return weeks;
  }, [leads]);

  const thisWeek = data[data.length - 1]?.count || 0;

  return (
    <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6 mb-6" data-testid="leads-chart">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <TrendingUp size={18} className="text-[#052F24]/40" />
          <h2 className="font-display font-bold text-sm tracking-wide uppercase text-[#052F24]/70">
            Weekly incoming leads
          </h2>
        </div>
        <span className="text-xs font-semibold text-[#6B7280]" data-testid="chart-this-week">
          This week: <span className="text-[#052F24] font-extrabold">{thisWeek}</span>
        </span>
      </div>
      <div className="h-44">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 0, left: -28, bottom: 0 }}>
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#6B7280" }} axisLine={false} tickLine={false} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#6B7280" }} axisLine={false} tickLine={false} />
            <Tooltip
              cursor={{ fill: "rgba(5,47,36,0.05)" }}
              contentStyle={{ borderRadius: 12, border: "1px solid #E5E7EB", fontSize: 13 }}
              formatter={(v) => [v, "Leads"]}
              labelFormatter={(l) => `Week of ${l}`}
            />
            <Bar dataKey="count" radius={[6, 6, 0, 0]} maxBarSize={48}>
              {data.map((d, i) => (
                <Cell key={d.key} fill={i === data.length - 1 ? "#DFFF00" : "#052F24"} stroke={i === data.length - 1 ? "#052F24" : "none"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
